import ShopItemsView from "../../components/shopItemsView/shopItemsView";

const WholeSalerOwnerView = () => {
    return (
        <div>
            <ShopItemsView update="/wholeseller-item-update" urlone="/wholesaler-owner-profile" deleteurl="/wholesaler-owner-profile"/>
        </div>
    )
}
export default WholeSalerOwnerView;